import { StandsAgent } from '@/components/modules/Application/IberiaCards/_shared/types/StandsAgent';

export class StandsAgentMap {
  public static findByEmail(agents: StandsAgent[], email: string | undefined): StandsAgent | undefined {
    if (!email) {
      return undefined;
    }
    const normalizedEmail = email.trim().toLowerCase();
    return agents.find((agent) => agent.email.trim().toLowerCase() === normalizedEmail);
  }
}
